import React, { useEffect, useState } from 'react';
import { api } from '../../contexts/AuthContext';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Switch } from '../../components/ui/switch';

export default function PerfAccessTab() {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get('/perf/access').then(r => setAdmins(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const toggle = async (a) => {
    try {
      await api.put('/perf/access', { user_id: a.id, grant: !a.granted });
      setAdmins(list => list.map(x => x.id === a.id ? { ...x, granted: !a.granted } : x));
      toast.success(`${a.name} ${!a.granted ? 'granted' : 'removed from'} performance review access`);
    } catch (e) { toast.error(e.response?.data?.detail || 'Update failed'); }
  };

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#6B3FA0]" /></div>;

  return (
    <div className="max-w-2xl space-y-3" data-testid="perf-access-tab">
      <p className="text-xs text-[#8E85A0]">Granted admins can see the dashboard, open reviews, complete director reviews and send summaries. Only you can manage this list.</p>
      <div className="rounded-xl border border-[#DED8EB] bg-white divide-y divide-[#F0ECF7]">
        {admins.map(a => (
          <div key={a.id} className="flex items-center gap-3 px-3 py-2.5" data-testid={`access-row-${a.id}`}>
            <div className="flex-1">
              <p className="text-sm font-bold text-[#2D1B4E]">{a.name}</p>
              <p className="text-[11px] text-[#8E85A0]">{a.email}</p>
            </div>
            <Switch checked={a.granted} onCheckedChange={() => toggle(a)} data-testid={`access-toggle-${a.id}`} />
          </div>
        ))}
        {admins.length === 0 && <p className="px-3 py-8 text-center text-sm text-[#8E85A0]">No other administrators found.</p>}
      </div>
    </div>
  );
}
